import { useState } from "react";
import "./login.css";
import { Link } from "react-router-dom";
import { Row, Col, InputGroup } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { addData } from "../../Utility/API";
import { useNavigate } from "react-router-dom";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Toaster from "../../components/Toast";
import { ErrorToast } from "../../components/Toast/message";
import Loader from "../../components/Loader";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [passwordShow, setPasswordShow] = useState(false);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoadinig] = useState(false);
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    let data = {
      login: email,
      passwd: password,
    };

    if (email && password) {
      let url = `${endPoints.api.LOGIN_ENDPOINT}`;
      setIsLoadinig(true);
      await addData(url, data)
        .then((response) => {
          setIsLoadinig(false);
          console.log("data", response.data);
          if (response.data.status === "success") {
            dispatch({
              type: Actions.LOGIN,
              data: { user: response.data },
            });
            sessionStorage.setItem("session", JSON.stringify(response.data.data.sessionId));
            sessionStorage.setItem("user", JSON.stringify(response.data));
            navigate("/Home");
          } else {
            ErrorToast(response.data.message)

          }
        })
        .catch((error) => {
          setIsLoadinig(false);
          console.error(error);
        });
    }
  };
  return (
    <div>
      <section className="login-page-section">
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div className="login-form-div">
          <Form
            className="login-form"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <h2 className="mb-4">Login</h2>
            <Form.Group className="mb-3" controlId="EMAIL">
              <Form.Control
                required
                placeholder="EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Form.Control.Feedback type="invalid">
                Please enter valid email
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 password-box" controlId="PASSWORD">
              <Form.Control
                required
                placeholder="PASSWORD"
                type={passwordShow ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <div
                className="show-icon"
                onClick={() => {
                  setPasswordShow(!passwordShow);
                }}
              >
                <AiFillEyeInvisible />
              </div>
              <Form.Control.Feedback type="invalid">
                Please enter password.
              </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group className="mb-3 flex-div" id="formGridCheckbox">
              <Form.Check type="checkbox" label="Remember my email." />
              <a
                onClick={() => navigate("/ForgotPassword")}
                className="forget-login-a"
              >
                Forgot your password?
              </a>
            </Form.Group> */}

            <div className="login-btn-last  mt-5">
              <Button
                className="login-btn-form"
                variant="primary"
                // onClick={HandleSubmit1}
                //onClick={handleSubmit}
                type="submit"
              >
                Login
              </Button>
            </div>
          </Form>
        </div>
      </section>
    </div>
  );
};

export default Login;
